import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';

export const postSalesCorporateLead = (val) => async (dispatch) => {
  const {
    leadId,
    leadStatus,
    comm_id,
    isNewContract,
    LockIn,
    MGPerSlot,
    MGSlots,
    TagsNoPost,
    agreementContractLength,
    agreementSigningDate,
    clientShare,
    commercialType,
    companyShare,
    costPerSlot,
    detailsProvide,
    installationAmount,
    pODate,
    pONumber,
    paymentMode,
    paymentTerms,
    products,
    paymentTermsDesc,
    revenueShare,
    revenueSlots,
    securityDeposit,
    slotsNoFourWheeler,
    slotsNoTwoWheeler,
    subAmt,
    takeEtaxes,
    takePerct,
    totalAmount,
    totalContract,
    yearlyInclin,
    anyOther,
    billAddressLine1,
    billAddressLine2,
    billGeoCityId,
    billGeoStateId,
    billPinId,
    expectedLive,
    gstFile,
    gstNumber,
    gstRegis,
    isSEZ,
    marketingReq,
    materialPhotos,
    materialVideos,
    overnight,
    po_woNumber,
    portForwarding,
    remarks,
    shipAddressLine1,
    shipAddressLine2,
    shipGeoCityId,
    shipGeoStateId,
    shipPinId,
    twowheelers,
    po_woCopy,
    agreementContractUpload,
    agreementContractPeriodFrom,
    agreementContractPeriodTo,
    pOUpload,
    toTime,
    fromTime,
    pickDate,
    scope_of_civil_work,
    gateDetails,
    categoryInventory,
    nonGstFile,
    tags,
    payment,
    increament,
    installationData,
    installation_charge,
    paymentDueDays,
    latePayCharge,
    clientData,
    solution_type,
    milestone,
    InvoiceModuleData,
    rel_docs,
    pocData,
    revenue_nature,
    revenue_type,
    invoice_type,
    services,
    shipFileUpload,
    variable_services,
    fixed_services
  } = val;
  const data = {
    lead_id: `${leadId}`,
    leadStatus: `${leadStatus}`,
    comm_id:`${comm_id}`,
    isNewContract:`${isNewContract}`,
    security_deposit: `${securityDeposit}`,
    four_wheeler_slots: `${slotsNoFourWheeler}`,
    two_wheeler_slots: `${slotsNoTwoWheeler}`,
    expected_live_date: `${expectedLive}`,
    marketing_requirement: `${marketingReq}`,
    no_of_tags: `${TagsNoPost}`,
    port_forwarding: `${portForwarding}`,
    scope_of_civil_work: `${scope_of_civil_work}`,
    remarks: `${remarks}`,
    contract_copy: `${po_woCopy}`,
    contract_number: `${po_woNumber}`,
    is_sez: `${isSEZ}`,
    working_timing: `${pickDate}`,
    site_photo: materialPhotos,
    site_video: materialVideos,
    contract_type: `${detailsProvide}`,
    file_upload: `${shipFileUpload}`,
    contract_details: [
      {
        contract_document: `${agreementContractUpload}`,
        contract_sign_date: `${agreementSigningDate}`,
        contract_from_date: `${agreementContractPeriodFrom}`,
        contract_to_date: `${agreementContractPeriodTo}`,
        contract_period: `${agreementContractLength}`,
      },
    ],
    po_details: [
      {
        po_document: `${pOUpload}`,
        po_number: `${pONumber}`,
        po_date: `${pODate}`,
      },
    ],
    gst_details: [
      {
        gst_registered: `${gstRegis}`,
        gst_number: `${gstNumber}`,
        gst_document: `${gstFile}`,
        upload_non_gst_disclosure_form: `${nonGstFile}`,
      },
    ],
    parking_rules: [
      {
        overnight_parking_allowed: `${overnight}`,
        two_wheeler_allowed_with_car: `${twowheelers}`,
        start_time: `${fromTime}`,
        end_time: `${toTime}`,
        other_rule: `${anyOther}`,
      },
    ],
    commercial: [
      {
        commercial_type_id: `${commercialType}`,
        description: 'commercial_description',
        client_share: `${clientShare}`,
        company_share: `${companyShare}`,
        cost_per_slot: `${costPerSlot}`,
        no_of_mg_slots: `${MGSlots}`,
        take: `${takeEtaxes}`,
        take_percentage: `${takePerct}`,
        installation_amount: `${installationAmount}`,
        latePayCharge: `${latePayCharge}`,
        subscription_amount: `${subAmt}`,
        payment_terms_id: `${paymentTerms}`,
        product_id: `${products}`,
        payment_mode: `${paymentMode}`,
        total_contract_length: `${totalContract}`,
        contract_lockin_period: `${LockIn}`,
        yearly_inclination: `${yearlyInclin}`,
        total_amount: `${totalAmount}`,
        revenue_share_slot: `${revenueSlots}`,
        revenue_share: `${revenueShare}`,
        mg_cost_per_slot: `${MGPerSlot}`,
        payment_term_desciption: `${paymentTermsDesc}`,
        payment_due_days: `${paymentDueDays}`,
        solution_type: `${solution_type}`,
        expected_live_date:`${expectedLive}`,
        rel_docs: `${rel_docs}`,
        revenue_nature: `${revenue_nature}`,
        revenue_type: `${revenue_type}`,
        invoice_type: `${invoice_type}`,
      },
    ],
    bill_to: [
      {
        address_line_1: `${billAddressLine1}`,
        address_line_2: `${billAddressLine2}`,
        geo_state_id: `${billGeoStateId}`,
        geo_city_id: `${billGeoCityId}`,
        geo_pin_code: `${billPinId}`,
      },
    ],
    ship_to: [
      {
        address_line_1: `${shipAddressLine1}`,
        address_line_2: `${shipAddressLine2}`,
        geo_state_id: `${shipGeoStateId}`,
        geo_city_id: `${shipGeoCityId}`,
        geo_pin_code: `${shipPinId}`,
      },
    ],
    
    // gates: [...gateDetails],
    tags: [...tags],
    increament: [...increament],
    payment:[...payment],
    installation: installationData,
    hardware: [...categoryInventory],
    client: clientData,
    milestone: milestone,
    InvoiceModuleData:InvoiceModuleData,
    pocData:pocData,

  };
  if(leadStatus === 9){
    data.gates = [...gateDetails];
    data.variable_services = variable_services
    data.fixed_services = fixed_services
  }
  // console.log(data); return false;
  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSales.createPostCorporate
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};
export const postSalesApartmentLead = (val) => async (dispatch) => {
  const {
    leadId,
    leadStatus,
    LockIn,
    MGPerSlot,
    MGSlots,
    TagsNoPost,
    agreementContractLength,
    agreementSigningDate,
    clientShare,
    commercialType,
    companyShare,
    costPerSlot,
    detailsProvide,
    installationAmount,
    pODate,
    pONumber,
    paymentMode,
    paymentTerms,
    paymentTermsDesc,
    products,
    revenueShare,
    revenueSlots,
    securityDeposit,
    slotsNoFourWheeler,
    slotsNoTwoWheeler,
    subAmt,
    takeEtaxes,
    takePerct,
    totalAmount,
    totalContract,
    yearlyInclin,
    anyOther,
    billAddressLine1,
    billAddressLine2,
    billGeoCityId,
    billGeoStateId,
    billPinId,
    expectedLive,
    gstFile,
    gstNumber,
    gstRegis,
    marketingReq,
    materialPhotos,
    materialVideos,
    overnight,
    po_woNumber,
    portForwarding,
    remarks,
    shipAddressLine1,
    shipAddressLine2,
    shipGeoCityId,
    shipGeoStateId,
    shipPinId,
    twowheelers,
    po_woCopy,
    agreementContractUpload,
    agreementContractPeriodFrom,
    agreementContractPeriodTo,
    pOUpload,
    // toTime,
    // fromTime,
    pickDate,
    gateDetails,
    scope_of_civil_work,
    categoryInventory,
    nonGstFile,
    paymentDueDays,
    installationData,
    tags,
    payment,
    increament,
    latePayCharge,
    clientData,
    solution_type,
    milestone,
    InvoiceModuleData,
    rel_docs,
    shipFileUpload,
  } = val;
  const data = {
    lead_id: `${leadId}`,
    leadStatus: `${leadStatus}`,
    security_deposit: `${securityDeposit}`,
    four_wheeler_slots: slotsNoFourWheeler,
    two_wheeler_slots: slotsNoTwoWheeler,
    expected_live_date: `${expectedLive}`,
    marketing_requirement: `${marketingReq}`,
    no_of_tags: `${TagsNoPost}`,
    port_forwarding: `${portForwarding}`,
    scope_of_civil_work: `${scope_of_civil_work}`,
    remarks: `${remarks}`,
    contract_copy: `${po_woCopy}`,
    contract_number: `${po_woNumber}`,
    working_timing: `${pickDate}`,
    site_photo: materialPhotos,
    site_video: materialVideos,
    contract_type: `${detailsProvide}`,
    file_upload: `${shipFileUpload}`,
    contract_details: [
      {
        contract_document: `${agreementContractUpload}`,
        contract_sign_date: `${agreementSigningDate}`,
        contract_from_date: agreementContractPeriodFrom,
        contract_to_date: agreementContractPeriodTo,
        contract_period: agreementContractLength,
      },
    ],
    po_details: [
      {
        po_document: `${pOUpload}`,
        po_number: `${pONumber}`,
        po_date: `${pODate}`,
      },
    ],
    gst_details: [
      {
        gst_registered: `${gstRegis}`,
        gst_number: `${gstNumber}`,
        gst_document: `${gstFile}`,
        upload_non_gst_disclosure_form: `${nonGstFile}`,
      },
    ],
    parking_rules: [
      {
        overnight_parking_allowed: `${overnight}`,
        two_wheeler_allowed_with_car: `${twowheelers}`,
        /* start_time: `${fromTime}`,
        end_time: `${toTime}`, */
        other_rule: `${anyOther}`,
      },
    ],
    // gates: [...gateDetails],
    hardware: [...categoryInventory],
    commercial: [
      {
        commercial_type_id: commercialType,
        description: `${paymentTermsDesc}`,
        client_share: clientShare,
        company_share: companyShare,
        cost_per_slot: costPerSlot,
        no_of_mg_slots: MGSlots,
        take: takeEtaxes,
        take_percentage: takePerct,
        installation_amount: installationAmount,
        latePayCharge: `${latePayCharge}`,
        subscription_amount: subAmt,
        payment_terms_id: paymentTerms,
        product_id: products,
        payment_mode: `${paymentMode}`,
        total_contract_length: `${totalContract}`,
        contract_lockin_period: `${LockIn}`,
        yearly_inclination: `${yearlyInclin}`,
        total_amount: `${totalAmount}`,
        revenue_share_slot: `${revenueSlots}`,
        revenue_share: `${revenueShare}`,
        mg_cost_per_slot: `${MGPerSlot}`,
        payment_due_days: `${paymentDueDays}`,
        solution_type: `${solution_type}`,
        rel_docs: `${rel_docs}`
      },
    ],
    bill_to: [
      {
        address_line_1: `${billAddressLine1}`,
        address_line_2: `${billAddressLine2}`,
        geo_state_id: billGeoStateId,
        geo_city_id: billGeoCityId,
        geo_pin_code: billPinId,
      },
    ],
    ship_to: [
      {
        address_line_1: `${shipAddressLine1}`,
        address_line_2: `${shipAddressLine2}`,
        geo_state_id: shipGeoStateId,
        geo_city_id: shipGeoCityId,
        geo_pin_code: shipPinId,
      },
    ],
    installation: installationData,
    tags: [...tags],
    increament: [...increament],
    payment:[...payment],

    client: clientData,
    milestone: milestone,
    InvoiceModuleData:InvoiceModuleData

  };
  if(leadStatus === 9){
    data.gates = [...gateDetails];
  }
      // console.log(data); return false;

  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSales.createPostApartment
  );
  if (res?.data?.response.status === true) {
    // const { data } = res;
    return true;
  }
};
export const postSalesSupplyLead = (val) => async (dispatch) => {
  const {
    leadId,
    LockIn,
    MGPerSlot,
    MGSlots,
    agreementContractLength,
    agreementSigningDate,
    clientShare,
    commercialType,
    companyShare,
    costPerSlot,
    detailsProvide,
    installationAmount,
    pODate,
    pONumber,
    paymentMode,
    paymentTerms,
    revenueShare,
    revenueSlots,
    securityDeposit,
    subAmt,
    takeEtaxes,
    takePerct,
    totalAmount,
    totalContract,
    yearlyInclin,
    anyOther,
    billAddressLine1,
    billAddressLine2,
    billGeoCityId,
    billGeoStateId,
    billPinId,
    gstFile,
    gstNumber,
    gstRegis,
    isSEZ,
    overnight,
    po_woNumber,
    portForwarding,
    remarks,
    shipAddressLine1,
    shipAddressLine2,
    shipGeoCityId,
    shipGeoStateId,
    shipPinId,
    twowheelers,
    po_woCopy,
    agreementContractUpload,
    agreementContractPeriodFrom,
    agreementContractPeriodTo,
    pOUpload,
    toTime,
    fromTime,
    pickDate,
    scope_of_civil_work,
    gateDetails,
    slotsRevenue4Car,
    slotsRevenue2Bike,
    parkCommission,
    categoryInventory,
    nonGstFile,
    agreementDocument,
    marketingSignageCount,
    marketingSignageType,
    approachVideo,
    slots2MgBike,
    slots4MgCar,
    shipFileUpload,
  } = val;
  const data = {
    lead_id: `${leadId}`,
    security_deposit: `${securityDeposit}`,
    four_wheeler_slots_mg: `${slots2MgBike}`,
    two_wheeler_slots_mg: `${slots4MgCar}`,
    four_wheeler_slots_revenue: `${slotsRevenue4Car}`,
    two_wheeler_slots_revenue: `${slotsRevenue2Bike}`,
    cost_per_slot: `${costPerSlot}`,
    park_commision: `${parkCommission}`,
    agreement_document: agreementDocument,
    signage_requirements_number: `${marketingSignageCount}`,
    signage_requirements_type: `${marketingSignageType}`,
    port_forwarding: `${portForwarding}`,
    scope_of_civil_work: `${scope_of_civil_work}`,
    remarks: `${remarks}`,
    contract_copy: `${po_woCopy}`,
    contract_number: `${po_woNumber}`,
    is_sez: `${isSEZ}`,
    working_timing: `${pickDate}`,
    approach_video: approachVideo,
    contract_type: `${detailsProvide}`,
    file_upload: `${shipFileUpload}`,
    contract_details: [
      {
        contract_document: `${agreementContractUpload}`,
        contract_sign_date: `${agreementSigningDate}`,
        contract_from_date: agreementContractPeriodFrom,
        contract_to_date: agreementContractPeriodTo,
        contract_period: agreementContractLength,
      },
    ],
    po_details: [
      {
        po_document: `${pOUpload}`,
        po_number: `${pONumber}`,
        po_date: `${pODate}`,
      },
    ],
    gst_details: [
      {
        gst_registered: `${gstRegis}`,
        gst_number: `${gstNumber}`,
        gst_document: `${gstFile}`,
        upload_non_gst_disclosure_form: `${nonGstFile}`,
      },
    ],
    parking_rules: [
      {
        overnight_parking_allowed: `${overnight}`,
        two_wheeler_allowed_with_car: `${twowheelers}`,
        start_time: `${fromTime}`,
        end_time: `${toTime}`,
        other_rule: `${anyOther}`,
      },
    ],
    commercial: [
      {
        commercial_type_id: `${commercialType}`,
        description: '',
        client_share: `${clientShare}`,
        company_share: `${companyShare}`,
        cost_per_slot: `${costPerSlot}`,
        no_of_mg_slots: `${MGSlots}`,
        take: `${takeEtaxes}`,
        take_percentage: `${takePerct}`,
        installation_amount: `${installationAmount}`,
        subscription_amount: `${subAmt}`,
        payment_terms_id: `${paymentTerms}`,
        payment_mode: `${paymentMode}`,
        total_contract_length: `${totalContract}`,
        contract_lockin_period: `${LockIn}`,
        yearly_inclination: `${yearlyInclin}`,
        total_amount: `${totalAmount}`,
        revenue_share_slot: `${revenueSlots !== '' ? revenueSlots : 0}`,
        revenue_share: `${revenueShare !== '' ? revenueShare : 0}`,
        mg_cost_per_slot: `${MGPerSlot}`,
      },
    ],
    bill_to: [
      {
        address_line_1: `${billAddressLine1}`,
        address_line_2: `${billAddressLine2}`,
        geo_state_id: `${billGeoStateId}`,
        geo_city_id: `${billGeoCityId}`,
        geo_pin_code: `${billPinId}`,
      },
    ],
    ship_to: [
      {
        address_line_1: `${shipAddressLine1}`,
        address_line_2: `${shipAddressLine2}`,
        geo_state_id: `${shipGeoStateId}`,
        geo_city_id: `${shipGeoCityId}`,
        geo_pin_code: `${shipPinId}`,
      },
    ],
    gates: [...gateDetails],
    hardware: [...categoryInventory],
  };
  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSales.createPostSupply
  );
  if (res?.data?.status === true) {
    return true;
  }
  return false;
};
